/**
 * intake-answer.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

/**
 * An {@link IntakeAnswer} encapsulates an {@link IntakeStep} identifier
 * and a user-supplied value.
 */
export class IntakeAnswer
{
  /**
   * Construct a new {@link IntakeAnswer}.
   *
   * @param id
   *        The numeric identifier that represents the corresponding {@link
   *        IntakeStep} to the server.
   * @param value
   *        The value of the corresponding {@link IntakeStep}.
   * @param provider
   *        (Optional) The full name of the user who supplied the value.
   */
  constructor (
    public id : number,
    public value : any,
    public provider? : string)
  {
    /* Nothing. */
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/algorithms/structure/intake-answer.ts